import ApiFile from '@/modules/document/models/file/api-file.ts';
import { TableId } from '@/modules/common/enums/table-id.enum.ts';
import type { DocumentFileDto } from '@/modules/document/dto/document-file.dto.ts';

export default class DocumentFile extends ApiFile {
  tableId: TableId;
  parentId: number;
  number: number;
  user: string;
  signCount: number;
  documentId: number;
  isLast: boolean;
  downloadName: string;

  constructor(response: DocumentFileDto) {
    super(response);
    this.tableId = response['PARENT_TABLE_ID'];
    this.parentId = response['PARENT_ID'];
    this.number = response['Номер'];
    this.user = response['Пользователь'];
    this.signCount = response['ЭП'];
    this.documentId = response['DOC_ID'];
    this.isLast = Number(response['Индикатор']) > 0;
    this.downloadName = `${this.documentId}_${this.revision}_${this.name}`;
  }
}
